"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

export default function AboutLayout({ children }) {
  const isdark = useIsDark();
  return (
    <div>
      {/* left top  */}
      <section className="relative translate-x-0 -translate-y-100 xl:translate-y-0">
        <div
          className={twMerge(
            "absolute top-[1042px] left-[-289px] w-[412px] h-[169px] rounded-full blur-[100px]",
            isdark ? "bg-[#8593E8] opacity-20" : "bg-[#A1ADF5] opacity-60"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[1200px] left-[-162px] w-[417px] h-[170px] rounded-full blur-[120px]",
            isdark ? "bg-[#5D6EF3] opacity-20" : "bg-[#2A40E7] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[1374px] left-[-313px] w-[398px] h-[163px] rounded-full blur-[100px]",
            isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60"
          )}
        />
      </section>

      {/* left middle */}
      <section className="relative translate-x-0 md:-translate-y-220 xl:translate-y-0">
        <div
          className={twMerge(
            "absolute top-[2293px] left-[-147px] w-[300px] h-[262px] rounded-full blur-[100px] rotate-[45deg]",
            isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60"
          )}
        />
      </section>

      {/* right bottom */}
      {/* <section className="hidden sm:block relative -translate-y-350 lg:-translate-y-280 xl:translate-y-0">
        <div
          className={twMerge(
            "absolute top-[2590px] right-[-135px] w-[271px] h-[313px] rounded-full blur-[100px]",
            isdark ? "bg-[#8593E8] opacity-20" : "bg-[#A1ADF5] opacity-60"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[2843px] right-[-50px] w-[274px] h-[315px] rounded-full blur-[120px]",
            isdark ? "bg-[#5D6EF3] opacity-20" : "bg-[#2A40E7] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[3042px] right-[-154px] w-[262px] h-[300px] rounded-full blur-[100px]",
            isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60"
          )}
        />
      </section> */}

      <div className="">{children}</div>
    </div>
  );
}
